const removeHyperlinks = html => html.replace(/href="([^'"]+)/g, '')

export default removeHyperlinks
